import posthog from "posthog-js";

export function eventTracking(
  eventName: string,
  properties?: Record<string, any> | null,
): void {
  // custom posthog event
  posthog.capture(eventName, properties);
}
